import { defaultClient } from '@mint-sdk/api-core';
import { z } from 'zod';

import {
  AmazonRegions,
  OmniAuthAuthorizeRequestSchema,
  OmniAuthAuthorizeResponseSchema,
} from '../../shared/schemas/AuthorizeSchema.js';

export const omniAuthAuthorize = defaultClient.mutation({
  url: 'omni-connector-service/auth/authorize' as const,
  method: 'POST',
  responseSchema: OmniAuthAuthorizeResponseSchema,
  requestSchema: OmniAuthAuthorizeRequestSchema,
  processResponse: (data) => data,
});

export const omniAuthAuthorizeV2 = defaultClient.mutation({
  url: 'omni-connector-service/v2/auth/authorize' as const,
  method: 'POST',
  responseSchema: OmniAuthAuthorizeResponseSchema,
  requestSchema: OmniAuthAuthorizeRequestSchema,
});

export const omniAuthAmazonAuthorize = defaultClient.mutation({
  url: 'omni-connector-service/auth/amazon/authorize' as const,
  method: 'POST',
  responseSchema: OmniAuthAuthorizeResponseSchema,
  requestSchema: OmniAuthAuthorizeRequestSchema,
  processResponse: (data) => data,
});

export const omniAuthAmazonAuthorizeV2 = defaultClient.mutation({
  url: 'omni-connector-service/v2/auth/amazon/authorize' as const,
  method: 'POST',
  responseSchema: OmniAuthAuthorizeResponseSchema,
  requestSchema: OmniAuthAuthorizeRequestSchema,
});

export const omniOAuth1Authorize = defaultClient.mutation({
  url: 'omni-connector-service/auth/authorize/oauth1' as const,
  method: 'POST',
  responseSchema: OmniAuthAuthorizeResponseSchema,
  requestSchema: OmniAuthAuthorizeRequestSchema,
  processResponse: (data) => data,
});

export const omniOAuth1AuthorizeV2 = defaultClient.mutation({
  url: 'omni-connector-service/v2/auth/authorize/oauth1' as const,
  method: 'POST',
  responseSchema: OmniAuthAuthorizeResponseSchema,
  requestSchema: OmniAuthAuthorizeRequestSchema,
});

export type OmniAuthAuthorizesBodyType = z.infer<
  typeof OmniAuthAuthorizeRequestSchema
>;

export type AmazonRegionsList =
  (typeof AmazonRegions)[keyof typeof AmazonRegions];
